import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { SiteSelectors } from '@next/core-lib/site';
import { Store } from '@ngrx/store';

import { ApplicationGroup } from '../../shared/models/authorizationService.model';
import { AppWizardModuleState } from '../models/app-wizard.model';
import { deleteApplicationGroup, getApplicationGroups } from '../store/actions/app-wizard.actions';
import { selectApplicationGroups } from '../store/selectors/app-wizard.selectors';

@Component({
  selector: 'app-wizard-delete-group',
  templateUrl: './app-wizard-delete-group.component.html',
  styleUrls: ['./app-wizard-delete-group.component.scss'],
  standalone: false,
})
export class AppWizardDeleteGroupComponent implements OnInit {
  @ViewChild(MatStepper) stepper: MatStepper;

  pageTitle$ = this.store.select(SiteSelectors.selectPageTitle);
  applicationGroups$ = this.store.select(selectApplicationGroups);
  applicationGroupFormGroup = this.formBuilder.group({
    appGroupNameCtrl: ['', Validators.required],
  });
  id: number;

  constructor(
    private readonly store: Store<AppWizardModuleState>,
    private formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(getApplicationGroups());
  }

  complete() {
    this.id = (
      this.applicationGroupFormGroup.get('appGroupNameCtrl').getRawValue() as ApplicationGroup
    ).id as number;
    this.store.dispatch(deleteApplicationGroup({ id: this.id }));
    this.store.dispatch(getApplicationGroups());
    this.stepper.next();
  }
}
